import axios from 'axios';
import qs from 'qs';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/storyWeb';

export default function addStory(data) {
    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${authToken}`,
        },
    };

    return (
        axios.post(API_URL, qs.stringify(data), config)
        .then(res => {            
            // console.log("res: ", res);
            return res.data;
        })
        .catch(err => {
            // console.log("err: ", err);
            return err;
        })
    );
}
